module.exports = __webpack_public_path__ + "static/media/hair (64).0d9a5213.jpg";